import axios from 'axios';

export const getAboutUs = async () => {
    try {
        const response = await axios.get('/api/about-us');
        return response.data;
    } catch (error) {
        console.error('Error fetching about us:', error);
        throw error;
    }
}

export const getPrivacyPolicy = async () => {
    try {
        const response = await axios.get('/api/privacy-policy');
        return response.data;
    } catch (error) {
        console.error('Error fetching privacy policy:', error);
        throw error;
    }
}